import React from 'react';

import {connect} from 'react-redux';

import cloudAnim from './cloudanimation'

import Footer from './footer'


import './calendar.css';

class Calendar extends React.Component {

    constructor(props) {
        
        super();
    
    this.state = {
        pic: "",
        number: 0,
        
    }

    this.status = "off";
    this.pics = [];
    
    }

   
    componentDidMount () {
        cloudAnim();
    }

render () {

    return (
        <div className="tablewrap">
        <div className="tablewrap2">

        <div className="tabletitlewrap">
    <h1 className="tabletitle">Kalenteri</h1>
    </div>

        <div className="tableintro">

 

        <div className="calendar-wrap">
            
            <div className="month-block">

                <div className="white-line"></div>
                <p className="month-block-title">2026</p>
                <div className="white-line"></div>

            <p className="month-block-title">ELOKUU</p>
                <p className="month-block-text">20.8.-31.8. Busan International Comedy Festival, Etelä-Korea</p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>

            <p className="month-block-title">KESÄKUU </p>
                <p className="month-block-text">25.7. Yksityistilaisuus, Turku</p>
                <p className="month-block-text"></p>

            <p className="month-block-title">KESÄKUU </p>
                <p className="month-block-text">12.6. Pro Sirkus, Stoa, Helsinki</p>
                <p className="month-block-text"></p>

            <p className="month-block-title">TOUKOKUU</p>
                <p className="month-block-text">31.5. Rauhaa & Respektii, Turun kauppatori</p>
                <p className="month-block-text">19.5. Kouluesiintymisiä, Nousiainen</p>

            <p className="month-block-title">HUHTIKUU</p>
                <p className="month-block-text"></p>
                <p className="month-block-text">3.4. Aura Company -avoinlava, Turku</p>
            
            <p className="month-block-title">HELMIKUU 2026</p>
                <p className="month-block-text">20.2. Jongleeraustyöpaja, Auta Lasta ry, Turku</p>
                <p className="month-block-text">11.2. Kulttuurikeskus Aurora, Helsinki</p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>

            <p className="month-block-title">TAMMIKUU 2026</p>
                <p className="month-block-text">17.1. Kota-Fon Festival, Djanglamey, Benin</p>
                <p className="month-block-text">3.1. Saturday Festival, Villa Karo, Grand Popo, Benin</p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>

                <div className="white-line"></div>
                <p className="month-block-title">2025</p>
                <div className="white-line"></div>

                <p className="month-block-title">JOULUKUU 2025</p>
                <p className="month-block-text">27.12. - 30.1.2026, Villa Karo, Grand Popo, Benin</p>
                <p className="month-block-text">5.12. Yksityistilaisuus, Turku, Valomatkaajat</p>

                <p className="month-block-title">MARRASKUU 2025</p>
                <p className="month-block-text">19.11. Yksityistilaisuus, Helsinki</p>
                <p className="month-block-text">9.11. Circus with Kai Kuutamo, Barker Teatteri, Turku</p>
                <p className="month-block-text">8.11. Circus with Kai Kuutamo, Barker Teatteri, Turku</p>
                <p className="month-block-text">5.11. MörkÖ Festivaali, Kustavi, Valomatkaajat</p>

                <p className="month-block-title">SYYSKUU 2025</p>
                <p className="month-block-text">27.9. Turun Seudun Yksinhuoltajat ry, Turku</p>
                <p className="month-block-text">20.9. Rauman Silakkamarkkinat, Rauma</p>
                <p className="month-block-text">13.9. September Open, Rohan Tallit, Taalintehdas</p>
                <p className="month-block-text">8.9. - 12.9. Italia</p>

                <p className="month-block-title">ELOKUU 2025</p>
                <p className="month-block-text">30.8. Laustepäivä, Turku</p>
                <p className="month-block-text">30.8. Killin markkinat, Raisio</p>
                <p className="month-block-text">21.8. Visiitti, Rantaryrttikatu 1, Kaarina, Tupakarkelot</p>
                <p className="month-block-text">20.8. Merituulikoti, Sairaalakatu 6, Uusikaupunki, Tupakarkelot</p>
                <p className="month-block-text">20.8. Rauhakoti, Lukkosepänkatu 2, Uusikaupunki, Tupakarkelot</p>
                <p className="month-block-text">19.8. Sauvon palvelukeskus, Hakkistentie 4, Sauvo, Tupakarkelot</p>
                <p className="month-block-text">19.8. Paltanpuiston palvelukeskus, Paltantie 4, Paimio, Tupakarkelot</p>
                <p className="month-block-text">13.8. Iltatoritapahtuma, Loimaa</p>
                <p className="month-block-text">12.8. Jaala-koti, Jaalakuja 2, Kustavi, Tupakarkelot</p>
                <p className="month-block-text">12.8. Ankkuri ja Poiju, Nuortenkodintie 1, Taivassalo, Tupakarkelot</p>
                <p className="month-block-text">2.8. Yli-Marolan 4H-kotieläinpiha, Lahti</p>

                <p className="month-block-title">HEINÄKUU 2025</p>

                <p className="month-block-text">28.7. Kurjenmäkikoti 2, Turku, Tupakarkelot</p>
                <p className="month-block-text">28.7. Kurjensiipi, Turku, Tupakarkelot</p>
                <p className="month-block-text">21.7. Kulkurin Valssi, Turku, Tupakarkelot</p>
                <p className="month-block-text">21.7. Runosmäen vanhuskeskus, Turku, Tupakarkelot</p>
                <p className="month-block-text">14.7. Kerttuli, Turku, Tupakarkelot</p>
                <p className="month-block-text">14.7. Mäntykoti Yli-Maaria, Turku, Tupakarkelot</p>
                <p className="month-block-text">10.7. Pajavasara Circus Concert, Turun Konserttitalo</p>
                <p className="month-block-text">7.7. Liinahaka, Turku, Tupakarkelot</p>
                <p className="month-block-text">7.7. Portsakoti, Turku, Tupakarkelot</p>
                <p className="month-block-text">6.7. Pajavasara Circus Concert, Turun Konserttitalo</p>

                <p className="month-block-title">KESÄKUU 2025</p>

                <p className="month-block-text">18.6. - 27.6. Italia / Espanja</p>
                <p className="month-block-text">16.6. Saloranta, Jongleeraustyöpaja, Naantali</p>
                <p className="month-block-text">14.6. Hämeen Keskiaikafestivaali, Rohan Tallit, Hämeenlinna</p>
                <p className="month-block-text">13.6. Hämeen Keskiaikafestivaali, Rohan Tallit, Hämeenlinna</p>
                <p className="month-block-text">7.6. Tjarnabio Theatre, Reykjavik, Islanti</p>
                <p className="month-block-text">5.6. Earstravaganza, White Lotus Venue, Reykjavik, Islanti</p>
                <p className="month-block-text">5.6. Tjarnabio Theatre, Reykjavik, Islanti</p>
                <p className="month-block-text">4.6. Purrlesque, National Theatre of Iceland</p>
                <p className="month-block-text">3.6. Työpaja, Hringleikur, Reykjavik, Islanti</p>
                
                
                <p className="month-block-title">TOUKOKUU 2025</p>

                <p className="month-block-text">27.5. Torakkailta, Köysiteatteri, Turku</p>
                <p className="month-block-text">27.5. Riihikoti-palvelukeskus, Riihikoski, Tupakarkelot</p>
                <p className="month-block-text">27.5. Oripään palvelutalo, Oripää, Tupakarkelot</p>
                <p className="month-block-text">26.5. Palvelutalo Kotikarpalo, Kyrö, Tupakarkelot</p>
                <p className="month-block-text">26.5. Valmakoti, Lieto, Tupakarkelot</p>
                <p className="month-block-text">23.5. Kartanopuisto, Loimaa, Tupakarkelot</p>
                <p className="month-block-text">23.5. Kosken palvelukeskus, Koski tl, Tupakarkelot</p>
                <p className="month-block-text">22.5. Nuhjalan päiväkoti, Naantali</p>
                <p className="month-block-text">22.5. Suvirannan palvelukeskus, Marttila, Tupakarkelot</p>
                <p className="month-block-text">22.5. Tarvasjoen hyvinvointikeskus, Tarvasjoki, Tupakarkelot</p>
                <p className="month-block-text">20.5. Amandakoti, Lieto, Tupakarkelot</p>
                <p className="month-block-text">20.5. Teijuntupa, Lieto, Tupakarkelot</p>
                <p className="month-block-text">19.5. Katajakoti, Somero, Tupakarkelot</p>
                <p className="month-block-text">19.5. Satumaa, Somero, Tupakarkelot</p>
                <p className="month-block-text">17.5. FinFringe, Turku</p>
                <p className="month-block-text">16.5. FinFringe, Turku</p>
                <p className="month-block-text">15.5. FinFringe, Turku</p>
                <p className="month-block-text">15.5. Katavakoti, Rymättylä, Tupakarkelot</p>
                <p className="month-block-text">14.5. FinFringe, Turku</p>
                <p className="month-block-text">14.5. Alhola ja Alppila, Perniö, Tupakarkelot</p>
                <p className="month-block-text">14.5. Perniön palvelukeskus, Perniö, Tupakarkelot</p>
                <p className="month-block-text">11.5. Äitienpäivän Torisirkuskarnevaali, Turku (FinFringe)</p>
                <p className="month-block-text">8.5. Yritystilaisuus, Tallinna, Viro</p>
                <p className="month-block-text">7.5. Vuokkokoti, Turku, Tupakarkelot</p>
                <p className="month-block-text">1.5. Valpperin Urheilutalo, Nousiainen</p>

                <p className="month-block-title">HUHTIKUU 2025</p>

                <p className="month-block-text">30.4. Raunistulan koulu, Turku (2 esitystä)</p>
                <p className="month-block-text">29.4. Nahkurin pihan päiväkoti, Turku</p>
                <p className="month-block-text">29.4. Aurinkokodit, Naantali, Tupakarkelot</p>
                <p className="month-block-text">29.4. Birgittakoti, Naantali, Tupakarkelot</p>
                <p className="month-block-text">17.4. Koivukoto, Laitila, Tupakarkelot</p>
                <p className="month-block-text">17.4. Kalannin palvelukeskus, Kalanti, Tupakarkelot</p>
                <p className="month-block-text">16.4. Silverbacken, Västanfjärd, Tupakarkelot</p>
                <p className="month-block-text">16.4. Almakoti, Kemiö, Tupakarkelot</p>
                <p className="month-block-text">15.4. Kukonkallion hoivakodit, Salo, Tupakarkelot</p>
                <p className="month-block-text">15.4. Campuskoti Merihelmi, Salo, Tupakarkelot</p>
                <p className="month-block-text">14.4. Paltanpuiston palvelukeskus, Paimio, Tupakarkelot</p>
                <p className="month-block-text">14.4. Sauvon palvelukeskus, Sauvo, Tupakarkelot</p>
                <p className="month-block-text">12.4. Hangon katutapahtuma perheille, Hanko</p>
                <p className="month-block-text">11.4. Rauhakoti, Uusikaupunki, Tupakarkelot</p>
                <p className="month-block-text">11.4. Merituulikoti, Uusikaupunki, Tupakarkelot</p>
                <p className="month-block-text">10.4. Ankkuri ja Poiju, Taivassalo, Tupakarkelot</p>
                <p className="month-block-text">10.4. Jaala-koti, Kustavi, Tupakarkelot</p>
                <p className="month-block-text">9.4. Kuivela-koti, Mynämäki, Tupakarkelot</p>
                <p className="month-block-text">9.4. Häävuoren palvelukeskus, Mynämäki, Tupakarkelot</p>
                <p className="month-block-text">8.4. Moisiokoti, Nousiainen, Tupakarkelot</p>
                <p className="month-block-text">8.4. Luukan palvelukeskus, Masku, Tupakarkelot</p>
                <p className="month-block-text">4.4. Kuntouttava yksikkö, Parainen, Tupakarkelot</p>
                <p className="month-block-text">4.4. Piikkiökoti, Kaarina, Tupakarkelot</p>
                <p className="month-block-text">3.4. Maununkoti, Rusko, Tupakarkelot</p>
                <p className="month-block-text">3.4. Hulvelan palvelukeskus, Raisio, Tupakarkelot</p>
                <p className="month-block-text">2.4. Grannas, Nauvo, Tupakarkelot</p>
                <p className="month-block-text">2.4. Regnbågen, Korpoo, Tupakarkelot</p>

    
                <p className="month-block-title"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>
                <p className="month-block-text"></p>




                <div className="white-line"></div>
                <p className="month-block-title">2024</p>
                <div className="white-line"></div>

                <p className="month-block-title">JOULUKUU 2024</p>
                <p className="month-block-text">14.12. Pikkujoulut, Circus Lounge, Turku</p>
                <p className="month-block-text">4.12. Itsenäisyysjuhla, Ylöjärvi</p>

                <p className="month-block-title">MARRASKUU 2024</p>
                <p className="month-block-text">30.11. Mikaelin Seurakuntakoti, Turku</p>
                <p className="month-block-text">29.11. Messukeskus, yritystilaisuus, Turku</p>
                <p className="month-block-text">16.11. Yritystilaisuus, Helsinki</p>
                <p className="month-block-text">9.11. Sirkus Aikamoinen, Helsinki</p>
                
                <p className="month-block-title">LOKAKUU 2024</p>
                <p className="month-block-text">27.10. JONG, Sigyn-sali, Turku</p>
                <p className="month-block-text">25.10. JONG, Sigyn-sali, Turku</p>
                <p className="month-block-text">12.10. Joenzoo, Näyttämö-teatteri, Joensuu</p>
                <p className="month-block-text">11.10. Joenzoo, Näyttämö-teatteri, Joensuu</p>
                <p className="month-block-text">10.10. Joenzoo, Näyttämö-teatteri, Joensuu</p>
                <p className="month-block-text">5.10. Kärkkäinen, Lahti (2 esitystä)</p>
                

                <p className="month-block-title">SYYSKUU 2024</p>
                <p className="month-block-text">21.9. Rauman Silakkamarkkinat (2 esitystä), Rauma</p>
                <p className="month-block-text">14.9. Kauppatori Pop-Up Circus, Turku</p>
                <p className="month-block-text">8.9. Littoisten Markkinat, Littoinen</p>
                <p className="month-block-text">7.9. September Open, Sirkuskunnan Narrit, Taalintehdas (2 esitystä)</p>
                <p className="month-block-text">7.9. Kaarina-talo, Merkkarit & Kai Kuutamo, Kaarina</p>

                <p className="month-block-title">ELOKUU 2024</p>
                <p className="month-block-text">31.8. Cafe Vinssi, Särkisalo</p>
                <p className="month-block-text">31.8. Illallinen Halisten taivaan alla, Turku</p>
                <p className="month-block-text">29.8. Itämeripäivä, Forum Marinum, Turku</p>
                <p className="month-block-text">25.8. Mynämäen MLL 100v, Mynämäki</p>
                <p className="month-block-text">24.8. Tallinn Fringe Festival, Tallinna, Viro</p>
                <p className="month-block-text">23.8. Tallinn Fringe Festival, Tallinna, Viro</p>
                <p className="month-block-text">22.8. Tallinn Fringe Festival, Tallinna, Viro</p>
                <p className="month-block-text">18.8. Lasten Festivaali, Kirjasto, Turku</p>
                <p className="month-block-text">10.8. Rusko-päivät, Rusko</p>
                <p className="month-block-text">6.8. Pansion Sirkus esittää: Eikka Alatalo - Motör Circus, Turku</p>
                <p className="month-block-text">3.8. Pansion Sirkus esittää: Sirkus Supiainen - Citroën Jumper, Turku</p>
                
                <p className="month-block-title">HEINÄKUU 2024</p>
                <p className="month-block-text">27.7. Bar Bizarre, DJ Herttakuningas, Salo</p>
                <p className="month-block-text">27.7. Yksityistilaisuus, Turku</p>
                <p className="month-block-text">26.7. Pansion Sirkus esittää: Duo Color Express - TT-1000, Turku</p>
                <p className="month-block-text">23.7. Kukkakeppien askartelupaja, Pansion Sirkus, Turku</p>
                <p className="month-block-text">20.7. Tall Ships Races, Turku, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">16.7. Jongleerauspallojen askartelupaja, Pansion Sirkus, Turku</p>
                <p className="month-block-text">12.7. Sirkus Supiaisen katusirkuspäivä, Joensuu</p>
                <p className="month-block-text">11.7. PopKatuTähtiKisa, Joensuu</p>                
                <p className="month-block-text">7.7. Magenta Juggling Convention, Helsinki</p>
                <p className="month-block-text">6.7. Magenta Juggling Convention, Helsinki</p>
                <p className="month-block-text">5.7. Pansion Sirkus avoimet ovet, Turku</p>
                <p className="month-block-text">4.7. Pansion Sirkus avoimet ovet, Turku</p>
                <p className="month-block-text">1.7. Pansion Sirkus avoimet ovet, Turku</p>

                <p className="month-block-title">KESÄKUU 2024</p>
                <p className="month-block-text">30.6. Pansion Sirkus avoimet ovet, Turku</p>
                <p className="month-block-text">29.6. Yksityistilaisuus, Pansion Sirkus, Turku</p>
                <p className="month-block-text">25.6. Merkkarit & Kai Kuutamo, Parainen</p>
                <p className="month-block-text">19.6. Työttömien aamupäivä, Pansion Sirkus, Turku</p>
                <p className="month-block-text">18.6. Yksityistilaisuus, Turku</p>
                <p className="month-block-text">16.6. Munamarkkinat, Laitila</p>
                <p className="month-block-text">14.6. Kaseva Festivaali, Juontaja, Littoinen</p>
                <p className="month-block-text">13.6. Kiva Loma Kulmilla, Työpaja, Aunelan palloiluhalli</p>
                <p className="month-block-text">12.6. Kiva Loma Kulmilla, Työpaja, Aunelan palloiluhalli</p>
                <p className="month-block-text">11.6. Kiva Loma Kulmilla, Työpaja, Aunelan palloiluhalli</p>                
                <p className="month-block-text">7.6. Kiva Loma Kulmilla, Työpaja, Pansion koulun sali</p>
                <p className="month-block-text">6.6. Pansion Sirkus AVAJAISET 18.00, Juontaja ja järjestäjä, Turku</p>
                <p className="month-block-text">6.6. Kiva Loma Kulmilla, Työpaja, Pansion koulun sali</p>
                <p className="month-block-text">5.6. Kiva Loma Kulmilla, Työpaja, Pansion koulun sali</p>                
                <p className="month-block-text">2.6. Rauhaa & Respektii, Juontaja, Turku</p>
                <p className="month-block-text">1.6. Yksityistilaisuus, Turku</p>
                
                
                <p className="month-block-title">TOUKOKUU 2024</p>
                <p className="month-block-text">30.5. Pallivahan ala-aste, Turku</p>
                <p className="month-block-text">23.5. Nappulalaakso, Kaarina</p>
                <p className="month-block-text">21.5. Heinikonkadun päiväkoti, Turku</p>
                <p className="month-block-text">20.5. Aunelan Pilke-päiväkoti, Turku</p>
                <p className="month-block-text">18.5. Kadunvarsietkot, Turun Kauppatori</p>
                <p className="month-block-text">18.5. Jongleeraustyöpajat, Brinkkala, Turkuseura</p>
                <p className="month-block-text">17.5. Yritystilaisuus, Turku (vaitiolosopimus)</p>
                <p className="month-block-text">11.5.  FinFringe, Hansa-tori, Turku</p>
                <p className="month-block-text">10.5.  FinFringe, Hansa-tori, Turku</p>
                <p className="month-block-text">9.5.  FinFringe, Hansa-tori, Turku</p>
                <p className="month-block-text">8.5.  FinFringe, Hansa-tori, Turku</p>
                <p className="month-block-text">5.5. Circusstad Festival, Rotterdam, Hollanti</p>
                <p className="month-block-text">4.5. Circusstad Festival, Rotterdam, Hollanti</p>
                <p className="month-block-text">3.5. Circusstad Festival, Rotterdam, Hollanti</p>
                <p className="month-block-text">2.5. Circusstad Festival, Rotterdam, Hollanti</p>

                <p className="month-block-title">HUHTIKUU 2024</p>
                <p className="month-block-text">30.4. Norlandia Apila, Rusko</p>
                <p className="month-block-text">25.4. Kurittulan koulu, Masku (2 esitystä)</p>
                <p className="month-block-text">20.4. Maailman Sirkuspäivä, Turun Kauppatori</p>

                <p className="month-block-title">MAALISKUU 2024</p>
                <p className="month-block-text">16.3. Aura Company Open Stage, Turku</p>
                <p className="month-block-text">2.3. Yksityistilaisuus, Circus Lounge, Turku</p>

                <p className="month-block-title">HELMIKUU 2024</p>
                <p className="month-block-text">16.2. Karhuvaltio, Dynamo, Turku, Merkkarit & Kai Kuutamo</p>

            <div className="white-line"></div>
                <p className="month-block-title">2023</p>
                <div className="white-line"></div>

                <p className="month-block-title">JOULUKUU 2023</p>
                <p className="month-block-text">10.12. Syvälahden koulu, Turku, Kai Kuutamo Show</p>
                <p className="month-block-text">9.12. Valon Polku, Turku, Les Hanuleurs - Valomatkaajat (3 esitystä)</p>
                <p className="month-block-text">8.12. Valon Polku, Turku, Les Hanuleurs - Valomatkaajat (3 esitystä)</p>
                <p className="month-block-text">7.12. Valon Polku, Turku, Les Hanuleurs - Valomatkaajat (3 esitystä)</p>
                <p className="month-block-text">6.12. Valon Polku, Turku, Les Hanuleurs - Valomatkaajat (3 esitystä)</p>

                <p className="month-block-title">MARRASKUU 2023</p>
                <p className="month-block-text">23.11. Helsingin Taidemuseo, Helsinki</p>

                <p className="month-block-title">LOKAKUU 2023</p>
                <p className="month-block-text">19.10. Vimma, Turku, Merkkarit & Kai Kuutamo</p>

                <p className="month-block-title">SYYSKUU 2023</p>
                <p className="month-block-text">10.9. Littoisten Markkinat, Littoinen, Kai Kuutamo Show</p>
                <p className="month-block-text">9.9. September Open, Taalintehdas, Sirkuskunnan Narrit</p>
                
                <p className="month-block-title">ELOKUU 2023</p>
                <p className="month-block-text">31.8. Kirjastoautokiertue, Uittamo, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">31.8. Kirjastoautokiertue, Harittu, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">31.8. Kirjastoautokiertue, Ispoinen, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">30.8. Kirjastoautokiertue, Kastu, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">30.8. Kirjastoautokiertue, Itäharju, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">30.8. Kirjastoautokiertue, Laukkavuori, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">30.8. Kirjastoautokiertue, Petrelius, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">30.8. Kirjastoautokiertue, Luolavuori, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">29.8. Voivalan Lastentalo, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">26.8. Killin Markkinat, Raisio, Kai Kuutamo Show</p>
                <p className="month-block-text">18.8. Taiteiden Yö, Lieto, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">17.8. Taiteiden Yö, Turku, Les Hanuleurs (3 esitystä)</p>
                <p className="month-block-text">13.8. Multi Bueno Festivaali, Turku, Juontaja / Järjestäjä</p>
                <p className="month-block-text">6.8. Seikkailupuisto, Turku, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">5.8. klo 16.00, Les Hanuleurs, Kristiinankatu 5, Turku</p>
                <p className="month-block-text">5.8. klo 14.00, Les Hanuleurs, Kristiinankatu 1, Turku</p>
                <p className="month-block-text">5.8. klo 12.00, Les Hanuleurs, Kristiinankatu 1, Turku</p>
                <p className="month-block-text">4.8. klo 17.00, Les Hanuleurs, Kristiinankatu 5, Turku</p>
                <p className="month-block-text">4.8. klo 16.00, Les Hanuleurs, Kristiinankatu 5, Turku</p>
                
                <p className="month-block-title">HEINÄKUU 2023</p>
                <p className="month-block-text">31.7. Seikkailupuisto, Turku, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">29.7. Kulttuurilossi, Kuuskajaskari, Les Hanuleurs - Maininki</p>
                <p className="month-block-text">22.7. Karunan Unikeon Markkinat, Karuna, Kai Kuutamo Show</p>
                <p className="month-block-text">1.7. Harpin Kioski, Harvaluoto, Merkkarit & Kai Kuutamo (PERUTTU)</p>

                <p className="month-block-title">KESÄKUU 2023</p>
                <p className="month-block-text">18.6. Vekara-Varkaus, Varkaus, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">12.6. Kirjastoautokiertue, Kastu, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">12.6. Kirjastoautokiertue, Kärsämäki, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">12.6. Kirjastoautokiertue, Takakirves, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">10.6. Avoimet Kylät, JussiMatti, Itä-Aure, Kai Kuutamo Show</p>
                <p className="month-block-text">6.6. Kirjastoautokiertue, Lauste, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">6.6. Kirjastoautokiertue, Kurala, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">6.6. Kirjastoautokiertue, Kohmo, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">6.6. Kirjastoautokiertue, Halinen, Turku, Kai Kuutamo Unplugged</p>
                <p className="month-block-text">2.6. Kesäkadun Avajaiset, Turku, Kai Kuutamo Show</p>

                <p className="month-block-title">TOUKOKUU 2023</p>
                <p className="month-block-text">31.5. Suvi Suloinen -tapahtuma, Turun pääkirjasto, Kai Kuutamo Show</p>
                <p className="month-block-text">27.5. Yksityistilaisuus, Taivassalo, Kai Kuutamo Show</p>
                <p className="month-block-text">24.5. Voivalan Lastentalo, Kaarina, Kai Kuutamo Show (PERUTTU)</p>
                <p className="month-block-text">22.5. Nahkurin päiväkoti, Turku, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">20.5. PikkuProvinssi, Seinäjoki, Kai Kuutamo Show</p>
                <p className="month-block-text">1.5. Vapputapahtuma, Kaarina, Kai Kuutamo Show</p>

                <p className="month-block-title">HUHTIKUU 2023</p>
                <p className="month-block-text">30.4. Kulttuurikeskus Aurora, Espoo, Merkkarit & Kai Kuutamo</p>
                <p className="month-block-text">21.4. Yritystilaisuus, Turku, Kai Kuutamo Show</p>

                <p className="month-block-title">MAALISKUU 2023</p>
                <p className="month-block-text">10.3. Empon koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">9.3. Valkeavuoren koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">9.3. Piispanlähteen alakoulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">8.3. Rungon koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">8.3. Hovirinnan koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">7.3. Auranlaakson koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">7.3. Ristikallion koulu, Kaarina, Kai Kuutamo Show</p>
                <p className="month-block-text">6.3. Piikkiön yhtenäiskoulu, Kaarina, Kai Kuutamo Show</p>

                <p className="month-block-title">HELMIKUU 2023</p>
                <p className="month-block-text">18.2. Sykerön tuolitapahtuma, kauppakeskus Hansa, Turku (2 esitystä)</p>

                <p className="month-block-title">TAMMIKUU 2023</p>
                <p className="month-block-text">26.1. Kristoffer-sali, Naantali, Merkkarit & Kai Kuutamo (2 esitystä)</p>

            <div className="white-line"></div>
                <p className="month-block-title">2022</p>
                <div className="white-line"></div>

                <p className="month-block-title">JOULUKUU 2022</p>
                    <p className="month-block-text">10.12. Yksityistilaisuus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">10.12. SPR Vastaanottokeskus, Turku</p>
                    <p className="month-block-text">10.12. Joulun polku, Hansa, Turku, Kai Kuutamo Show (3 esitystä)</p>
                    <p className="month-block-text">6.12. Valon Polku, Turku, Valomatkaajat (3 esitystä)</p>
                    <p className="month-block-text">5.12. Valon Polku, Turku, Valomatkaajat (3 esitystä)</p>
                    <p className="month-block-text">4.12. Valon Polku, Turku, Valomatkaajat (3 esitystä)</p>
                    <p className="month-block-text">3.12. Valon Polku, Turku, Valomatkaajat (3 esitystä)</p>
                    <p className="month-block-text">2.12. Piikkiön joulunavaus, Piikkiö, Tuliesitys Prasu</p>

                <p className="month-block-title">MARRASKUU 2022</p>
                    <p className="month-block-text">26.11. Barker-Teatterin avajaiset, Turku</p>
                    <p className="month-block-text">4.11. Lux Archipelago, Parainen, Valomatkaaja</p>
                    <p className="month-block-text">1.11. Mäntymäen päiväkoti, Turku, Kai Kuutamo Show</p>

                <p className="month-block-title">LOKAKUU 2022</p>
                    <p className="month-block-text">31.10. Varissuon koulu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">28.10. Jäkärlän koulu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">27.10. Friisilän koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">27.10. Kuloisten koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">26.10. Kerttulan koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">26.10. Ihalan koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">25.10. Kaanaan koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">25.10. Tikanmaan koulu, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">8.10. Yrittäjägaala 2022, Logomo, Turku, Tuliesitys Prasu feat. Toni Perttula</p>
                    <p className="month-block-text">6.10. Tapanilan Sirkussali Open Stage, Helsinki, Juontaja</p>
                    <p className="month-block-text">1.10. Allergia- ja Astmayhdistys Ry, Turku, Kai Kuutamo Show</p>

                <p className="month-block-title">SYYSKUU 2022</p>
                    <p className="month-block-text">18.9. Klo 14.00, Luostarin Välikatu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">18.9. Klo 12.30, Luostarin Välikatu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">15.9. Super Toivon Torstai, Höveli, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">14.9. Katariinan koulu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">14.9. Askaisten koulu, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">9.9. Hemmingin koulu, Masku, Kai Kuutamo Show</p>
                    <p className="month-block-text">8.9. Klo 18.30, Maailmanpuutarha, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">7.9. Kaskenlinnan Sairaala, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">5.9. Hoivakoti Kerttuli, Turku, Kai Kuutamo Show</p>                 
                    <p className="month-block-text">4.9. Väinö Linnan Aukio, Oijoijoi-festivaali, Tampere, Kai Kuutamo Show</p>
                    <p className="month-block-text">4.9. Laikun Lava, Tampere, Kai Kuutamo Show</p>
                    <p className="month-block-text">3.9. Näsinpuisto, Tampere, Kai Kuutamo Show</p>                    
                    <p className="month-block-text">3.9. Väinö Linnan Aukio, Oijoijoi-festivaali, Tampere, Kai Kuutamo Show</p>                    
                    <p className="month-block-text">3.9. Väinö Linnan Aukio, Oijoijoi-festivaali, Tampere, Kai Kuutamo Show</p>                    
                    <p className="month-block-text">2.9. Väinö Linnan Aukio, Oijoijoi-festivaali, Tampere, Kai Kuutamo Show</p>
                    <p className="month-block-text">2.9. Keskustori, Tampere, Kai Kuutamo Show</p>
                    <p className="month-block-text">2.9. Koskipuisto, Oijoijoi-festivaali, Tampere, Kai Kuutamo Show</p>
                    <p className="month-block-text">1.9. Hoivakoti Kulkurin Valssi, Turku, Kai Kuutamo Show</p> 

                <p className="month-block-title">ELOKUU 2022</p>

                    <p className="month-block-text">31.8. Klo 11-13, Fredrikanportaat, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">30.8. Hoivakoti Mäntyrinne, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">30.8. Hoivakoti Liinahaka, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">30.8. Mäntykoti Räntämäki, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">27.8. Yksityistilaisuus, Lappeenranta, Kai Kuutamo Show</p> 
                    <p className="month-block-text">26.8. Runosmäen vanhuskeskus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">26.8. Mäntykoti Yli-Maaria, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">26.8. Vuokkokoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">25.8. Kurjenmäkikoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">25.8. Kurjensiipi, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">25.8. Portsakoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">20.8. Yksityistilaisuus, Lieto, Kai Kuutamo Show</p> 
                    <p className="month-block-text">11.8. Vartiovuoren kesäteatteri, Turku, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">7.8. Kauppakeskus Sello, Espoo, Kai Kuutamo Show (2 esitystä)</p>
                    <p className="month-block-text">6.8. Arctic Ensemble Katusirkuskarnevaali, Kalasatama, Helsinki</p>
                    <p className="month-block-text">4.8. Tapahtumien Yö, Tallipiha, Tampere, Kai Kuutamo Show</p>

                <p className="month-block-title">HEINÄKUU 2022</p>
                    <p className="month-block-text">31.7. Ruukkikylä, Teijo, Kai Kuutamo Show</p>
                    <p className="month-block-text">30.7. Vanha Suurtori, Turku, Kai Kuutamo Non-Stop-Show</p>
                    <p className="month-block-text">29.7. Yksityistilaisuus, Uotila, Kai Kuutamo Show</p>
                    <p className="month-block-text">28.7. Vähätori, Turku, Kai Kuutamo Non-Stop-Show</p>
                    <p className="month-block-text">27.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">26.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">23.7. Unikeon Markkinat, Karuna, Kai Kuutamo Show</p>
                    <p className="month-block-text">22.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">20.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">12.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">8.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">6.7. Yksityistilaisuus, Jyväskylä, Kai Kuutamo Show</p>
                    <p className="month-block-text">4.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>
                    <p className="month-block-text">1.7. Pansion kisapuisto, Turku, Jongleeraustyöpaja 10.00-11.30</p>

                <p className="month-block-title">KESÄKUU 2022</p>
                    <p className="month-block-text">19.6. Pansio-päivä, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">18.6. Jukolan Viesti, Mynämäki, Kai Kuutamo Show</p>
                    <p className="month-block-text">18.6. Yksityistilaisuus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">18.6. Kauppilan umpipiha, Laitila, Sirkuskunnan Narri Urho</p>
                    <p className="month-block-text">17.6. Tipula, Laitila, Sirkustyöpaja</p>    
                    <p className="month-block-text">14.6. Iltatori, Aura, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">12.6. Kesä on maalla!, Askainen, Kai Kuutamo Show</p>
                    <p className="month-block-text">11.6. Yksityistilaisuus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">10.6. Kaseva Ry 30-vuotisjuhlat, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">6.6. Hotel Alfa, Gerani, Kreikka, Kai Kuutamo Show</p>
                    <p className="month-block-text">5.6. Hotel Alfa, Gerani, Kreikka, Kai Kuutamo Show</p>
                                    

                <p className="month-block-title">TOUKOKUU 2022</p>
                    <p className="month-block-text">30.5. Höveli, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">28.5. Circus Lounge, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">28.5. Yksityistilaisuus, Kaarina, Kai Kuutamo Show</p>
                    <p className="month-block-text">27.5. Maijamäen koulu, Naantali, Kendama-työpaja</p>
                    <p className="month-block-text">26.5. Circus Lounge, Turku, Jongleeraustyöpaja</p>
                    <p className="month-block-text">25.5. Suopellon koulu, Naantali, Kendama-työpaja</p>    
                    <p className="month-block-text">24.5. Päiväkoti Tammentupa, Lieto, Kai Kuutamo Show</p>
                    <p className="month-block-text">22.5. Jokisataman Avajaiset, Turku, Kai Kuutamo Show (4 esitystä)</p>
                    <p className="month-block-text">21.5. Jyrkkälä-päivä, Turku, Jongleeraustyöpaja</p>                    
                    <p className="month-block-text">20.5. Sauvon koulukeskus, Kai Kuutamo Show (2 esitystä)</p>
                    <p className="month-block-text">18.5. Taatilan koulu, Lieto, Kai Kuutamo Show (2 esitystä)</p>
                    <p className="month-block-text">17.5. Vistan koulu, Paimio, Kai Kuutamo Show</p>
                    <p className="month-block-text">14.5. Yksityistilaisuus, Raisio, Kai Kuutamo Show</p>
                    
                <p className="month-block-title">HUHTIKUU 2022</p>
                    <p className="month-block-text">30.4. Lempäälä Ideapark, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">23.4. Katariinan Karnevaalit, Kai Kuutamo Show, Turku</p>
                    <p className="month-block-text">15.4. Aura Company Open Stage, Turku</p>
                    
                <div className="white-line"></div>
                <p className="month-block-title">2021</p>
                <div className="white-line"></div>

                    <p className="month-block-title">JOULUKUU 2021</p>
                    <p className="month-block-text">14.12. Päiväkoti, Espoo, Joulupukki & Tempputonttu</p> 
                    <p className="month-block-text">14.12. Päiväkoti, Espoo, Joulupukki & Tempputonttu</p> 
                    <p className="month-block-text">11.12. Kulttuuritila Näkkäri, Salo, Merkkarit & Kai Kuutamo</p> 

                    <p className="month-block-title">MARRASKUU 2021</p>
                    <p className="month-block-text">26.11. Yritystilaisuus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">20.11. Yksityistilaisuus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">20.11. Avoin Jongleeraustyöpaja, Logomo, Turku klo 10.00-14.00</p> 

                    <p className="month-block-title">LOKAKUU 2021</p>
                    <p className="month-block-text">21.10. Avoin Jongleeraustyöpaja, Höveli, Turku klo 18.00-19.00</p> 
                    <p className="month-block-text">3.10. Taivassalon MLL 100V, Kai Kuutamo Show (PERUTTU)</p> 

                    <p className="month-block-title">SYYSKUU 2021</p>
                    <p className="month-block-text">25.9. Näyttämö Teatteri, Joensuu, Life Becomes Us</p> 
                    <p className="month-block-text">18.9. Seikkisrock, Turku, Merkkarit & Kai Kuutamo (PERUTTU)</p> 
                    <p className="month-block-text">11.9. September Open 2021, Taalintehdas, Sirkuskunnan Narrit</p> 
                    <p className="month-block-text">6.9. Puolukkatien Lastenkoti, Turku, Kai Kuutamo Show</p>

                    <p className="month-block-title">ELOKUU 2021</p>
                    <p className="month-block-text">29.8. Krookilan kotiseutukeskus, Raisio, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">28.8. Sutela Action, Kotka, Kai Kuutamo Show (PERUTTU)</p> 
                    <p className="month-block-text">25.8. Attendo Aviapolis, Vantaa, Sisäpihasirkus</p>
                    <p className="month-block-text">24.8. Saga Helapuisto, Helsinki, Sisäpihasirkus</p> 
                    <p className="month-block-text">24.8. Töölön palvelukeskus, Helsinki, Sisäpihasirkus</p> 
                    <p className="month-block-text">23.8. Saga Palvelutalo Tammilinna, Vantaa, Sisäpihasirkus</p>
                    <p className="month-block-text">19.8. Roihuvuoren palvelukeskus, Helsinki, Sisäpihasirkus (PERUTTU)</p>
                    <p className="month-block-text">17.8. Attendo Lassilan palvelukoti, Helsinki, Sisäpihasirkus</p>
                    <p className="month-block-text">12.8. Gastropub Löytö, Taiteiden Yö, Turku, Kai Kuutamo Show</p>      
                    <p className="month-block-text">7.8. Kirjurinluodon kesäteatteri, Pori, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">5.8. Stockmann, Turku, Kai Kuutamo Show</p>     
                    <p className="month-block-text">3.8. Kurikan museoalue, Kurikka, Matkalaukkusirkus (2 esitystä)</p> 
                    <p className="month-block-text">2.8. Jurvan monitoimihallia, Jurva, Matkalaukkusirkus (2 esitystä)</p> 
                    

                    <p className="month-block-title">HEINÄKUU 2021</p>
                    <p className="month-block-text">31.7. Sauvon Elopäivät, Sauvo, Kai Kuutamo Show (2 esitystä)</p>     
                    <p className="month-block-text">30.7. Rettigin portaikon Tapahtumamatto, Turku, Kai Kuutamo Show (klo 12 ja 13)</p>     
                    <p className="month-block-text">25.7. Swan European Regatta 2021, Turku, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">24.7. Rauman Pitsiviikot, Rauma, Merkkarit & Kai Kuutamo (klo 12 ja 13.30)</p> 
                    <p className="month-block-text">21.7. Ylöjärven museo, Ylöjärvi, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">20.7. Kurun ulkomuseo, Ylöjärvi, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">18.7. Krapin kesäteatteri, Tuusula, Merkkarit & Kai Kuutamo (klo 11 ja 15)</p> 
                    <p className="month-block-text">17.7. Viihdetaiteen SM-kisat, Kouvola, Kai Kuutamo Show</p> 
                    <p className="month-block-text">11.7. Hakamäen museoalue, Savitaipale, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">8.7. Ruusukujan palveluasunnot, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">6.7. Moikoistenkadun Lastenkoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">5.7. Vähäheikkilän perhetukikeskus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">3.7. Kristiinankadun Tapahtumamatto, Turku, Kai Kuutamo Show (klo 12, 13 ja 14)</p> 
                    <p className="month-block-text">2.7. Vuokkokoti, Turku, Sisäpihasirkus</p> 
                    <p className="month-block-text">1.7. Häävuoren palvelukeskus, Mynämäki, Sisäpihasirkus </p> 
                    <p className="month-block-text">1.7. Koivulehdon palvelukoti, Mietoinen, Sisäpihasirkus </p> 

                    <p className="month-block-title">KESÄKUU 2021</p>                
                    <p className="month-block-text">30.6. Kaskenlinnan sairaala, Turku, Sisäpihasirkus </p> 
                    <p className="month-block-text">29.6. Luukan palvelukeskus, Masku, Sisäpihasirkus </p> 
                    <p className="month-block-text">28.6. Aurikosäätiön palvelutalo, Naantali, Sisäpihasirkus </p> 
                    <p className="month-block-text">24.6. Saga Kaskenniitty, Turku, Sisäpihasirkus </p> 
                    <p className="month-block-text">24.6. Saga Kaskenpuisto, Turku, Sisäpihasirkus </p> 
                    <p className="month-block-text">23.6. Moisiokoti, Nousiainen, Sisäpihasirkus</p> 
                    <p className="month-block-text">23.6. Hulvelan palvelukeskus, Raisio, Sisäpihasirkus</p> 
                    <p className="month-block-text">18.6. Koskikoti / Kotiranta, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">18.6. Makslankadun lastenkoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">17.6. SPR Vastaanottokeskus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">17.6. Portsan Kehräkoti, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">17.6. Orikedon toimintakeskus, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">16.6. Mäntymäen perhekeskus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">15.6. Pormestarin toimintakeskus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">15.6. Toivolankadun toimintakeskus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">13.6. Lasten Laulukaupunki, Salo, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">11.6. Lakkatien erityislastenkoti, Turku, Kai Kuutamo Show</p> 
                    
                    <p className="month-block-title">TOUKOKUU 2021</p>
                    <p className="month-block-text">28.5. Kuloisten päiväkoti, Raisio, Kai Kuutamo Show</p>
                    <p className="month-block-text">27.5. Soinisten päiväkoti, Naantali, Kai Kuutamo Show</p> 
                    <p className="month-block-text">26.5. Uittamon päiväkoti, Turku, Merkkarit & Kai Kuutamo</p> 
                    <p className="month-block-text">25.5. Ristikallion päiväkoti, Kaarina, Kai Kuutamo Show (x3)</p> 
                    <p className="month-block-text">18.5. Pilke Päiväkoti Puolikko, Turku, Kai Kuutamo Show</p> 
                    <p className="month-block-text">11.5. Taimon Päiväkoti, Naantali, Kai Kuutamo Show</p> 


                    <p className="month-block-title">MAALISKUU 2021</p>
                    <p className="month-block-text">13.3. Kulttuuritalo Näkkäri, Salo, Merkkarit & Kai Kuutamo (PERUTTU)</p> 
                    
                    <p className="month-block-title">HELMIKUU 2021</p>
                
                    <p className="month-block-text">20.2. Ruskotalo, Rusko, Matkalaukkusirkus (PERUTTU)</p> 

                <div className="white-line"></div>
                <p className="month-block-title">2020</p>
                <div className="white-line"></div>

                    <p className="month-block-title">JOULUKUU 2020</p>
                
                    <p className="month-block-text">13.12. Viking Line, Amorella, Merkkarit & Kai Kuutamo (PERUTTU)</p>                                
                    <p className="month-block-text">12.12. Kolme Väriä, Aurinkobaletti, Turku, Kivinen Kuutamo - LIVE STREAM</p>

                    <p className="month-block-title">MARRASKUU 2020</p>
                    <p className="month-block-text">20.11. Parainen, yksityistilaisuus, Tuliesitys Prasu</p>                    
                    <p className="month-block-text">9.-13.11. Seinäjoki, Kulttuurikeskus Louhimo, Hai5-hanke</p>
                    <p className="month-block-text">7.11. Turku, yksityistilaisuus, Kai Kuutamo Show</p>                    
                    <p className="month-block-text">2.-6.11. Seinäjoki, Kulttuurikeskus Louhimo, Hai5-hanke</p>
                    <p className="month-block-text">1.11. Kauppakeskus Karisma, Lahti, Kai Kuutamo Show</p>


                    <p className="month-block-title">LOKAKUU 2020</p>
                    <p className="month-block-text">31.10. Kauppakeskus Goodman, Hämeenlinna, Kai Kuutamo Show</p>
                    <p className="month-block-text">26.10. Paimiosali, Paimio, Kai Kuutamo  (PERUTTU)</p>
                    <p className="month-block-text">22.10. Kaarina-talo, Kaarina, Matkalaukkusirkus</p>
                    <p className="month-block-text">21.10. Ampperi, Kaarina, Matkalaukkusirkus</p>
                    <p className="month-block-text">20.10. Pontela, Piikkiö, Matkalaukkusirkus</p>
                    <p className="month-block-text">16.10. Kauppakeskus Skanssi, Turku, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">5.10. Yksityistilaisuus, Kaarina, Kai Kuutamo Show</p>


                    <p className="month-block-title">SYYSKUU 2020</p>
                    <p className="month-block-text">30.9. Pilke-musiikkipäiväkoti Rumpali, Masku, Jonglööri Pihalla -kiertue</p>  
                    <p className="month-block-text">29.9. Pääskyvuoren päiväkoti, Turku (2 esitystä), Jonglööri Pihalla -kiertue</p>  
                    <p className="month-block-text">25.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">24.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">23.9. Särkänkoti, Orivesi, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">23.9. Tähtiniemi, Orivesi, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">22.9. Onninkoti, Orivesi, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">22.9. Attendo Ruusukuja, Orivesi, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">21.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">20.9. Kauppakeskus Veturi, Kouvola, Kai Kuutamon jongleerausarvonta</p>
                    <p className="month-block-text">19.9. Kauppakeskus Willa, Hyvinkää, Kai Kuutamo Show</p>
                    <p className="month-block-text">18.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">17.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">16.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">15.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">14.9. Sirkus Faktorin residenssi, Orivesi</p>
                    <p className="month-block-text">12.9. Logomo, Turku, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">11.9. Pilke-päiväkoti Aurora/Kipinä, Kaarina, Kai Kuutamo Show</p>
                    <p className="month-block-text">10.9. Lehmusvalkaman Vanhainkoti, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">10.9. Uittamon päiväkoti, Turku (2 esitystä), Kai Kuutamo Show</p>
                    <p className="month-block-text">9.9. Ruusukorttelin Hyvinvointikeskus, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">8.9. Kaanaan päiväkoti, Raisio (2 esitystä), Kai Kuutamo Show</p>


                    <p className="month-block-title">ELOKUU 2020</p>
                    <p className="month-block-text">31.8. Seniorisäätiö, Antinkoti, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">31.8. Seniorisäätiö, Mariankoti, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">29.8. Muinaistulien Yö, Kaarina (5 esitystä), Kai Kuutamo Show</p>
                    <p className="month-block-text">29.8. Lasten Laulukaupunki, Salo, Merkkarit & Kai Kuutamo</p>
                    <p className="month-block-text">27.8. Saga Kaskenniitty, Turku, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">25.8. Saga Kaskenpuisto, Turku, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">16.8. Hämeen Keskiaikafestivaali, Hämeenlinna (2 esitystä), Sirkuskunnan Narrit</p>
                    <p className="month-block-text">15.8. Hämeen Keskiaikafestivaali, Hämeenlinna (3 esitystä), Sirkuskunnan Narrit</p>
                    <p className="month-block-text">14.8. Hämeen Keskiaikafestivaali, Hämeenlinna (3 esitystä), Sirkuskunnan Narrit</p>
                    <p className="month-block-text">12.8. Roihuvuoren Monipuolinen Palvelukeskus, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">11.8. Yksityistilaisuus, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">11.8. Saga Tammilinna, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">11.8. Seniorisäätiö, Kannelkoti, Helsinki, Kai Kuutamo Show</p>
                    <p className="month-block-text">10.8. Sanervakoti, Helsinki, Kai Kuutamo Show</p>


                    <p className="month-block-title">HEINÄKUU 2020</p>
                    <p className="month-block-text">24.7. Villa Kaskimäki, Kirkkonummi, Sisäpihasirkus</p>
                    <p className="month-block-text">23.7. Kinaporin Palvelukeskus, Helsinki, Sisäpihasirkus</p>
                    <p className="month-block-text">22.7. Seniorisäätiö, Pakilakoti, Helsinki, Sisäpihasirkus</p>
                    <p className="month-block-text">21.7. Seikkailupuisto, Turku, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">14.7. Yksityistilaisuus, Turku, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text">9.7. Seikkailupuisto, Turku, Jonglööri Pihalla -kiertue</p>


                    <p className="month-block-title">KESÄKUU 2020</p>
                    <p className="month-block-text">17.6. Turun Nuorisokeskus Vimma, Turku, Merkkarit & Kai Kuutamo - LIVE STREAM</p>


                    <p className="month-block-title">TOUKOKUU 2020</p>
                    <p className="month-block-text">27.5. Attendo Haarla, Turku, Jonglööri Pihalla -kiertue</p>
                    <p className="month-block-text"></p>


                    <p className="month-block-title">MAALISKUU 2020</p>
                    <p className="month-block-text">12.3. Kaanaan päiväkoti, Raisio, Matkalaukkusirkus</p>
                    <p className="month-block-text">11.3. Pilke-päiväkoti Välskäri, Turku, Matkalaukkusirkus</p>
                    <p className="month-block-text">10.3. Pasalanpuiston päiväkoti, Raisio, Matkalaukkusirkus</p>
                    <p className="month-block-text">10.3. Leijapuiston päiväkoti, Raisio, Matkalaukkusirkus</p>
                    <p className="month-block-text">7.3. JDS 2020, Jyväskylä</p>
                    <p className="month-block-text">4.3. Pilke-päiväkoti Kanerva, Kaarina (2 esitystä), Matkalaukkusirkus</p>
                    <p className="month-block-text"></p>


                    <p className="month-block-title">HELMIKUU 2020</p>
                    <p className="month-block-text">29.2. Yksityistilaisuus, Taivassalo, Kai Kuutamo Show</p>
                    <p className="month-block-text">28.2. Touhula-päiväkoti, Salo (2 esitystä), Matkalaukkusirkus</p>
                    <p className="month-block-text">15.2. Lasten Syöpäpäivä, Sykerö Ry, Kauppakeskus Mylly, Turku (2 esitystä), Kai Kuutamo Show</p>
                    <p className="month-block-text">14.2. Cafe Mikael, Pansion Höveli, Turku, Kai Kuutamo Show</p>
                    <p className="month-block-text">8.2. Kauppakeskus Seppä, Jyväskylä (2 esitystä), Kai Kuutamo Show</p>
                    <p className="month-block-text">4.2. Hajalan päiväkoti, Salo, Matkalaukkusirkus</p>
                    <p className="month-block-text">2.2. MLL Mynämäki, Laurin koulu, Mynämäki, Kai Kuutamo Show</p>
                    <p className="month-block-text"></p>


                    <div className="white-line"></div>
                <p className="month-block-title">2019</p>
                <div className="white-line"></div>

                  
            </div>

            <div className="calendar-empty-block"></div>

        </div>

        </div>
            
            
        </div>
        <Footer />
        </div>
    )

}

}


const mapStateToProps = (state) => {
    return {
        texts: state.texts
    }
}

export default connect(mapStateToProps)(Calendar);